import api from 'api'
import { PROPOSAL_CANCEL } from '../constants/endpointKeys'
import { type IProposalDTO } from 'dto/ProposalDTO'

export const cancelProposal = async (proposalId: IProposalDTO['id']) => {
  return await api.put(`${PROPOSAL_CANCEL}/${proposalId}`).then((response) => {
    return response.data
  })
}
